import { render, staticRenderFns } from "./ConsumerMedical.vue?vue&type=template&id=513b9ff1"
import script from "./ConsumerMedical.vue?vue&type=script&lang=js"
export * from "./ConsumerMedical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports